<template>
	<div class="kc-maincontainer">
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="keylogincontainer">
			<div class="fp-heading d-flex align-items-center justify-content-center">
				<div>Forgot Your Password?</div>
			</div>

			<div class="mainlog mb-5">
				<div class="kc-fp-subhead mt-5">
					Please enter your email address and we will send<br />
					you instructions on how to create a new password
				</div>
				<div class="topDiv mt-5">
					<label class="keylabel">Email &nbsp;</label>
					<b-form-input
						class="labelbox"
						id="input-1"
						placeholder="Enter here"
						autofocus
						type="text"
						v-model.trim="$v.email.$model"
						@keyup="convertToLowerCase"
						@input="convertToLowerCase"
						:class="{ error: $v.email.$error }"
						v-on:keyup.enter="onEnter"
					></b-form-input>
					<div
						class="validationicon"
						v-if="$v.email.$dirty && !$v.email.required"
						v-b-popover.hover.top.v-danger="{ content: 'Required' }"
					>
						<img src="../../assets/deletepopupicon.svg" alt="" />
					</div>
					<div
						class="validationicon"
						v-if="!$v.email.maxLength && $v.email.required"
						v-b-popover.hover.top.v-danger="{
							content: `cannot enter more than 64 characters`,
						}"
						variant="primary"
					>
						<img src="../../assets/deletepopupicon.svg" alt="" />
					</div>
					<div
						class="validationicon"
						v-if="!$v.email.email && $v.email.required"
						v-b-popover.hover.top.v-danger="{
							content: 'Email is invalid',
						}"
					>
						<img src="../../assets/deletepopupicon.svg" alt="" />
					</div>
				</div>
			</div>

			<div class="text-center">
				<b-button class="addbtn pr-3 pl-3 mt-3" @click="forgotPassword()"
					>SUBMIT</b-button
				>
			</div>
			<div
				class="d-flex align-items-center justify-content-center text-center mt-4"
			>
				<img src="../../assets/kcbackbutton.svg" alt="" />
				<router-link to="/login">
					<div class="kc-reg-backtoprev ml-2">Back To Login</div>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import { forgotPassword } from "../../utils/apiFunctions";
import { required, email, maxLength } from "vuelidate/lib/validators";
import toast from "../mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";

export default {
	name: "forgotpassword",
	components: {
		Spinner,
	},
	data() {
		return {
			email: "",
			LoaderStatus: false,
		};
	},
	mixins: [toast],
	validations: {
		email: {
			required,
			email,
			maxLength: maxLength(64),
		},
	},
	methods: {
		onEnter() {
			this.forgotPassword();
		},
		// Forgot password function
		async forgotPassword() {
			this.$v.$touch();
			this.LoaderStatus = true;
			if (!this.$v.$invalid) {
				try {
					const res = await forgotPassword(this.email);
					if (res.status == 200) {
						this.LoaderStatus = false;
						setTimeout(function() {
							alert("Check your email id for recovery process");
						}, 100);
					} else {
						this.LoaderStatus = false;
						this.errorToast("Something went wrong! Try again");
					}
				} catch (error) {
					this.LoaderStatus = false;
					this.errorToast(`${error.response.data.error}`);
					throw new Error(`Forgotpassword Failed! status: ${error.status}`);
				}
			} else {
				this.LoaderStatus = false;
				this.errorToast("Invalid Email");
			}
		},
		// Converting text to lowercase
		convertToLowerCase() {
			this.email = this.email.toLowerCase();
		},
	},
};
</script>
